import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { useNavigate } from "react-router";
import Header from "../../Header/Header";
import { useParams } from "react-router-dom";
import Loader from "../../common/Loader";
library.add(fas);

const EditOffCanvance = (props) => {
  const navigate = useNavigate();

  const { id } = useParams();
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  const GetEditData = async () => {
    try {
      setLoading(true);
      const response = await getData(`/admin/setting/app-setup/${id}`);
      reset(response?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
    setValue,
  } = useForm();

  const imageFile = watch("logo");
  const imageFileQR = watch("qr_image");
  // const navigate = useNavigate();
  const onSubmit = async (data) => {
    try {
      setSubmitLoading(true);
      const finalData = new FormData();
      finalData.append("website_name", data?.website_name);
      finalData.append("contact_no", data?.contact_no);
      finalData.append("alt_contact_no", data?.alt_contact_no);
      finalData.append("email", data?.email);
      finalData.append("address", data?.address);
      finalData.append("second_address", data?.second_address);
      finalData.append("cancel_period", data?.cancel_period);
      finalData.append("gst_no", data?.gst_no);
      finalData.append("pan_no", data?.pan_no);
      finalData.append("cap_percent", data?.cap_percent);
      finalData.append("happy_customer", data?.happy_customer);
      finalData.append("delivered_orders", data?.delivered_orders);
      finalData.append("contact_person", data?.contact_person);
      finalData.append("tds_percentage", data?.tds_percentage);
      finalData.append("admin_percentage", data?.admin_percentage);
      finalData.append("website_url", data?.website_url);
      // finalData.append("packing_price", data?.packing_price);
      // finalData.append(
      //   "free_delivery_order_price",
      //   data?.free_delivery_order_price
      // );

      // finalData.append(
      //   "delivery_price_three_kilometer",
      //   data?.delivery_price_three_kilometer
      // );
      finalData.append("minimum_order", data?.minimum_order);
      // finalData.append("refer_percentage", data?.refer_percentage);
      // finalData.append("refer_by_order", data?.refer_by_order);
      // finalData.append("refer_to_order", data?.refer_to_order);
      // finalData.append("packing_quantity", data?.packing_quantity);

      // finalData.append("subscription_status", data?.subscription_status);

      finalData.append("lat", data?.lat);
      finalData.append("long", data?.long);
      finalData.append("return_charges", data?.return_charges);
      finalData.append("return_period", data?.return_period);
      finalData.append("logo", data?.logo[0]);
      if (data?.qr_image && typeof data?.qr_image !== "string" && data?.qr_image[0])
        finalData.append("qr_image", data?.qr_image[0]);

      //  finalData.append("customer_limit", data?.customer_limit);
      // finalData.append("refer_to_percentage", data?.refer_to_percentage);
      finalData.append("low_stock_day", data?.low_stock_day);
      finalData.append("daily_withdrawal", data?.daily_withdrawal);
      finalData.append("withdraw_accept_amount", data?.withdraw_accept_amount);
      finalData.append("pv", data?.pv);
      finalData.append(
        "affiliate_inactive_days",
        data?.affiliate_inactive_days,
      );
      const response = await putData(
        `/admin/setting/app-setup/${id}`,
        finalData,
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        navigate("/settings/app-setup");
        // props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    } finally {
      setSubmitLoading(false);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <Header title={"Edit App Setup"} link={"#"} />
      <section className="Create">
        <div className="back_btn_holder">
          <div onClick={() => navigate(`/settings/app-setup`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <Form.Label>Website Name</Form.Label>

                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="website_name"
                          placeholder="The Vishwaroop "
                          className={classNames("", {
                            "is-invalid": errors?.website_name,
                          })}
                          {...register("website_name", {
                            required: "Website name Is Required",
                            validate: (value) =>
                              value.length <= 200 ||
                              "Data must be 200 characters or less",
                          })}
                        />
                      </InputGroup>
                      {errors.website_name && (
                        <span className="text-danger">
                          {errors.website_name.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <Form.Label>Latitude</Form.Label>

                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="lat"
                          placeholder="Latitude"
                          maxLength={20}
                          className={classNames("", {
                            "is-invalid": errors?.lat,
                          })}
                          {...register("lat", {
                            required: "Latitude is required",
                            pattern: {
                              value: /^-?\d+(\.\d+)?$/,
                              message: "Enter a valid numeric latitude",
                            },
                            validate: (value) => {
                              const latitude = Number(value);

                              return (
                                (latitude >= -90 && latitude <= 90) ||
                                "Latitude must be between -90 and 90"
                              );
                            },
                          })}
                        />
                      </InputGroup>

                      {errors.lat && (
                        <span className="text-danger">
                          {errors.lat.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <Form.Label>Longitude</Form.Label>

                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="long"
                          placeholder="Longitude"
                          maxLength={20}
                          className={classNames("", {
                            "is-invalid": errors?.long,
                          })}
                          {...register("long", {
                            required: "Longitude is required",
                            pattern: {
                              value: /^-?\d+(\.\d+)?$/,
                              message: "Enter a valid numeric longitude",
                            },
                            validate: (value) => {
                              const longitude = Number(value);

                              return (
                                (longitude >= -180 && longitude <= 180) ||
                                "Longitude must be between -180 and 180"
                              );
                            },
                          })}
                        />
                      </InputGroup>

                      {errors.long && (
                        <span className="text-danger">
                          {errors.long.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Contact No</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name={`contact_no`}
                        placeholder="Mobile Number"
                        className={classNames("", {
                          "is-invalid": errors?.contact_no,
                        })}
                        {...register(`contact_no`, {
                          required: "Mobile Number is required",
                          validate: (value) =>
                            value.length === 10 ||
                            " Contact number must be exactly 10 digits",
                        })}
                        onKeyDown={(e) => {
                          const { key } = e;
                          const value = e.target.value;
                          if (key === "ArrowLeft" || key === "ArrowRight") {
                            return;
                          }
                          if (
                            !/[0-9]/.test(key) &&
                            key !== "Backspace" &&
                            key !== "Tab"
                          ) {
                            e.preventDefault();
                          }
                          // if (
                          //   value?.length >= 10 &&
                          //   key !== "Backspace" &&
                          //   key !== "Tab"
                          // ) {
                          //   e.preventDefault();
                          // }
                        }}
                      />
                    </InputGroup>
                    {errors.contact_no && (
                      <span className="text-danger">
                        {errors.contact_no.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Alternate Contact No</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name={`alt_contact_no`}
                        placeholder="Mobile Number"
                        className={classNames("", {
                          "is-invalid": errors?.alt_contact_no,
                        })}
                        {...register(`alt_contact_no`, {
                          required: "Mobile Number is required",
                          validate: (value) =>
                            value.length === 10 ||
                            " Contact number must be exactly 10 digits",
                        })}
                        onKeyDown={(e) => {
                          const { key } = e;
                          const value = e.target.value;
                          if (key === "ArrowLeft" || key === "ArrowRight") {
                            return;
                          }
                          if (
                            !/[0-9]/.test(key) &&
                            key !== "Backspace" &&
                            key !== "Tab"
                          ) {
                            e.preventDefault();
                          }
                          // if (
                          //   value?.length >= 10 &&
                          //   key !== "Backspace" &&
                          //   key !== "Tab"
                          // ) {
                          //   e.preventDefault();
                          // }
                        }}
                      />
                    </InputGroup>
                    {errors.alt_contact_no && (
                      <span className="text-danger">
                        {errors.alt_contact_no.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Email</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="email"
                        placeholder="Email"
                        className={classNames("", {
                          "is-invalid": errors?.email,
                        })}
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value:
                              /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/,
                            message: "Invalid Email address",
                          },
                          validate: (value) => {
                            // Extract the domain and TLD
                            const domainPattern =
                              /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/;
                            const match = value.match(domainPattern);
                            if (match) {
                              const domainParts = match[1].split(".");
                              const tld = match[2];

                              // Ensure the domain and TLD are not the same
                              if (domainParts[domainParts.length - 1] === tld) {
                                return "Domain and top-level domain must be different";
                              }
                            }
                            return true;
                          },
                        })}
                        onKeyDown={(e) => {
                          if (e.key === " ") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </InputGroup>
                    {errors.email && (
                      <span className="text-danger">
                        {errors.email.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <Form.Label>GST Number</Form.Label>

                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="gst_no"
                          placeholder="GST Number"
                          className={classNames("", {
                            "is-invalid": errors?.gst_no,
                          })}
                          {...register("gst_no", {
                            required: "GST Number is Required",
                            pattern: {
                              value:
                                /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                              message: "Enter a valid GST Number",
                            },
                            validate: (value) =>
                              value.length === 15 ||
                              "GST Number must be 15 characters",
                          })}
                        />
                      </InputGroup>
                      {errors.gst_no && (
                        <span className="text-danger">
                          {errors.gst_no.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <Form.Label>PAN Number</Form.Label>

                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="pan_no"
                          placeholder="PAN Number"
                          className={classNames("", {
                            "is-invalid": errors?.pan_no,
                          })}
                          {...register("pan_no", {
                            required: "PAN Number is Required",
                            pattern: {
                              value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                              message: "Enter a valid PAN Number",
                            },
                            validate: (value) =>
                              value.length === 10 ||
                              "PAN Number must be 10 characters",
                          })}
                        />
                      </InputGroup>
                      {errors.pan_no && (
                        <span className="text-danger">
                          {errors.pan_no.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Return Charges(percentage)</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`return_charges`}
                      placeholder="Return Charges"
                      className={classNames("", {
                        "is-invalid": errors?.return_charges, // Adjusted error checking
                      })}
                      {...register(`return_charges`, {
                        required: {
                          message: "Return Charges required ",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less", // Custom required message
                        },
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.return_charges && (
                      <span className="text-danger">
                        {errors.return_charges.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Return Period(days)</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`return_period`}
                      placeholder="Return Period"
                      className={classNames("", {
                        "is-invalid": errors?.return_period, // Adjusted error checking
                      })}
                      {...register(`return_period`, {
                        required: {
                          message: "Return Period required ", // Custom required message
                        },
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.return_period && (
                      <span className="text-danger">
                        {errors.return_period.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col> */}

              {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Cancel Period(Hour)</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`cancel_period`}
                      placeholder="Cancel Period"
                      className={classNames("", {
                        "is-invalid": errors?.cancel_period, // Adjusted error checking
                      })}
                      {...register(`cancel_period`, {
                        required: {
                          message: "Cancel Period required ", // Custom required message
                        },
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors.cancel_period && (
                      <span className="text-danger">
                        {errors.cancel_period.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col> */}

              {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Group>
                    <Form.Label>Default Delivery Range Days</Form.Label>

                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="delivery_range"
                        placeholder="Enter Default Delivery Range"
                        className={classNames("", {
                          "is-invalid": errors?.delivery_range,
                        })}
                        {...register("delivery_range", {
                          required: "Delivery Range Is Required",
                        })}
                          onKeyDown={(e) => {
                          // Allow left and right arrows and backspace
                          if (
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            e.key === "Backspace"
                          ) {
                            return;
                          }

                          // Allow only numbers
                          if (!/[\d]/.test(e.key)) {
                            e.preventDefault(); // Prevent non-numeric input
                          }
                        }}
                      />
                    </InputGroup>
                    {errors.delivery_range && (
                      <span className="text-danger">
                        {errors.delivery_range.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col> */}
              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Minimum Order (price)</Form.Label>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name={`minimum_order`}
                        placeholder="Minimum Order"
                        className={classNames("", {
                          "is-invalid": errors?.minimum_order, // Adjusted error checking
                        })}
                        {...register(`minimum_order`, {
                          required: {
                            message: "Minimum Order  are required ", // Custom required message
                          },
                        })}
                        onKeyDown={(e) => {
                          // Allow backspace, left arrow, right arrow, and digits
                          if (
                            !(
                              e.key === "Backspace" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight" ||
                              (e.key >= "0" && e.key <= "9")
                            )
                          ) {
                            e.preventDefault(); // Prevent default action for non-allowed keys
                          }
                        }}
                      />
                      {errors.minimum_order && (
                        <span className="text-danger">
                          {errors.minimum_order.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col> */}
              {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Delivery Price(Km)</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`delivery_price`}
                      placeholder="Delivery Price"
                      className={classNames("", {
                        "is-invalid": errors?.delivery_price,
                      })}
                      {...register(`delivery_price`, {
                        required: {
                          message: "price are required ",
                        },
                      })}
                      onKeyDown={(e) => {
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.delivery_price && (
                      <span className="text-danger">
                        {errors.delivery_price.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

               <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Delivery Price First Three Kilometer</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`delivery_price_three_kilometer`}
                      placeholder="Delivery Price First Three Kilometer"
                      className={classNames("", {
                        "is-invalid": errors?.delivery_price_three_kilometer,
                      })}
                      {...register(`delivery_price_three_kilometer`, {
                        required: {
                          message: "price are required ",
                        },
                      })}
                      onKeyDown={(e) => {
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.delivery_price_three_kilometer && (
                      <span className="text-danger">
                        {errors.delivery_price_three_kilometer.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col> */}
              {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Free Delivery Order Price</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`free_delivery_order_price`}
                      placeholder="Free Delivery Order Price"
                      className={classNames("", {
                        "is-invalid": errors?.free_delivery_order_price, // Adjusted error checking
                      })}
                      {...register(`free_delivery_order_price`, {
                        required: {
                          message: "price are required ", // Custom required message
                        },
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.free_delivery_order_price && (
                      <span className="text-danger">
                        {errors.free_delivery_order_price.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col> */}
              {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Subscription Status</Form.Label>
                  <Form.Group>
                    <Form.Check
                      type="switch"
                      id="subscription_status" // Give it an id for accessibility
                      label=""
                      name="subscription_status"
                      checked={watch("subscription_status")} // Assuming you're using react-hook-form to track state
                      onChange={(e) => {
                        setValue("subscription_status", e.target.checked);
                      }} // Update form state on toggle
                      className={classNames("", {
                        "is-invalid": errors?.subscription_status,
                      })}
                    />
                    {errors.subscription_status && (
                      <span className="text-danger">
                        {errors.subscription_status.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col> */}
              {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Packing Price</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`packing_price`}
                      placeholder="Returnable Days"
                      className={classNames("", {
                        "is-invalid": errors?.packing_price, // Adjusted error checking
                      })}
                      {...register(`packing_price`, {
                        required: {
                          message: "Price are required ", // Custom required message
                        },
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.packing_price && (
                      <span className="text-danger">
                        {errors.packing_price.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col> */}

              {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Packing quantity</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`packing_quantity`}
                      placeholder="Packing Quantity"
                      className={classNames("", {
                        "is-invalid": errors?.packing_quantity, // Adjusted error checking
                      })}
                      {...register(`packing_quantity`, {
                        required: {
                          message: "Packing Qunatiyt required ", // Custom required message
                        },
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.packing_quantity && (
                      <span className="text-danger">
                        {errors.packing_quantity.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>
             <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Customer Limit</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`customer_limit`}
                      placeholder="Customer Limit"
                      className={classNames("", {
                        "is-invalid": errors?.customer_limit, // Adjusted error checking
                      })}
                      {...register(`customer_limit`, {
                        required: {
                          message: "Customer Limit required ", // Custom required message
                        },
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.customer_limit && (
                      <span className="text-danger">
                        {errors.customer_limit.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col> */}

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>PV</Form.Label>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name={`pv`}
                        placeholder="PV"
                        className={classNames("", {
                          "is-invalid": errors?.pv, // Adjusted error checking
                        })}
                        {...register(`pv`, {
                          required: {
                            message: "PV required ",
                          },
                        })}
                        onKeyDown={(e) => {
                          // Allow backspace, left arrow, right arrow, and digits
                          if (
                            !(
                              e.key === "Backspace" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight" ||
                              (e.key >= "0" && e.key <= "9")
                            )
                          ) {
                            e.preventDefault(); // Prevent default action for non-allowed keys
                          }
                        }}
                      />
                      {errors.pv && (
                        <span className="text-danger">{errors.pv.message}</span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Referral Bonus Deactivation Days</Form.Label>

                    <Form.Group>
                      <Form.Control
                        type="text"
                        inputMode="numeric"
                        placeholder="Enter days (0–365)"
                        className={classNames("", {
                          "is-invalid": errors?.affiliate_inactive_days,
                        })}
                        {...register("affiliate_inactive_days", {
                          required:
                            "Referral Bonus Deactivation Days is required",
                          pattern: {
                            value: /^\d+$/,
                            message: "Only whole numbers are allowed",
                          },
                          validate: (value) => {
                            const num = Number(value);
                            if (num < 0 || num > 365) {
                              return "Value must be between 0 and 365";
                            }
                            return true;
                          },
                        })}
                        onKeyDown={(e) => {
                          if (
                            !/^\d$/.test(e.key) &&
                            ![
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              "Tab",
                              "Home",
                              "End",
                            ].includes(e.key) &&
                            !(e.ctrlKey || e.metaKey)
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />

                      {errors.affiliate_inactive_days && (
                        <span className="text-danger">
                          {errors.affiliate_inactive_days.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Happy Customers</Form.Label>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name={`happy_customer`}
                        placeholder="Happy Customers"
                        className={classNames("", {
                          "is-invalid": errors?.happy_customer, // Adjusted error checking
                        })}
                        {...register(`happy_customer`, {
                          required: {
                            message: "Happy Customers required ",
                          },
                        })}
                        onKeyDown={(e) => {
                          // Allow backspace, left arrow, right arrow, and digits
                          if (
                            !(
                              e.key === "Backspace" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight" ||
                              (e.key >= "0" && e.key <= "9")
                            )
                          ) {
                            e.preventDefault(); // Prevent default action for non-allowed keys
                          }
                        }}
                      />
                      {errors.happy_customer && (
                        <span className="text-danger">
                          {errors.happy_customer.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Order Deliverd</Form.Label>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name={`delivered_orders`}
                        placeholder="Order Deliverd"
                        className={classNames("", {
                          "is-invalid": errors?.delivered_orders, // Adjusted error checking
                        })}
                        {...register(`delivered_orders`, {
                          required: {
                            message: "Order Deliverd required ",
                          },
                        })}
                        onKeyDown={(e) => {
                          // Allow backspace, left arrow, right arrow, and digits
                          if (
                            !(
                              e.key === "Backspace" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight" ||
                              (e.key >= "0" && e.key <= "9")
                            )
                          ) {
                            e.preventDefault(); // Prevent default action for non-allowed keys
                          }
                        }}
                      />
                      {errors.delivered_orders && (
                        <span className="text-danger">
                          {errors.delivered_orders.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Low Stock Quantity Alert</Form.Label>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name={`low_stock_day`}
                        placeholder="Low Stock Quantity Alert"
                        className={classNames("", {
                          "is-invalid": errors?.low_stock_day, // Adjusted error checking
                        })}
                        {...register(`low_stock_day`, {
                          required: {
                            message: "Low Stock Quantity Alert required ",
                          },
                        })}
                        onKeyDown={(e) => {
                          // Allow backspace, left arrow, right arrow, and digits
                          if (
                            !(
                              e.key === "Backspace" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight" ||
                              (e.key >= "0" && e.key <= "9")
                            )
                          ) {
                            e.preventDefault(); // Prevent default action for non-allowed keys
                          }
                        }}
                      />
                      {errors.low_stock_day && (
                        <span className="text-danger">
                          {errors.low_stock_day.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Withdrawal Days Limit</Form.Label>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name={`daily_withdrawal`}
                        placeholder="Withdrawal Days Limit"
                        className={classNames("", {
                          "is-invalid": errors?.daily_withdrawal, // Adjusted error checking
                        })}
                        {...register(`daily_withdrawal`, {
                          required: {
                            message: "Withdrawal Days Limit required ",
                          },
                        })}
                        onKeyDown={(e) => {
                          // Allow backspace, left arrow, right arrow, and digits
                          if (
                            !(
                              e.key === "Backspace" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight" ||
                              (e.key >= "0" && e.key <= "9")
                            )
                          ) {
                            e.preventDefault(); // Prevent default action for non-allowed keys
                          }
                        }}
                      />
                      {errors.daily_withdrawal && (
                        <span className="text-danger">
                          {errors.daily_withdrawal.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Withdrawal Minimum Amount</Form.Label>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name={`withdraw_accept_amount`}
                        placeholder="Withdrawal Minimum Amount"
                        className={classNames("", {
                          "is-invalid": errors?.withdraw_accept_amount, // Adjusted error checking
                        })}
                        {...register(`withdraw_accept_amount`, {
                          required: {
                            message: "Withdrawal Minimum Amount required ",
                          },
                        })}
                        onKeyDown={(e) => {
                          // Allow backspace, left arrow, right arrow, and digits
                          if (
                            !(
                              e.key === "Backspace" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight" ||
                              (e.key >= "0" && e.key <= "9")
                            )
                          ) {
                            e.preventDefault(); // Prevent default action for non-allowed keys
                          }
                        }}
                      />
                      {errors.withdraw_accept_amount && (
                        <span className="text-danger">
                          {errors.withdraw_accept_amount.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Withdrawal Cap Percentage</Form.Label>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name={`cap_percent`}
                        placeholder="Withdrawal Cap Percentage"
                        className={classNames("", {
                          "is-invalid": errors?.cap_percent, // Adjusted error checking
                        })}
                        {...register(`cap_percent`, {
                          required: "Withdrawal Cap Percentage is required",

                          min: {
                            value: 0,
                            message:
                              "Percentage must be greater than or equal to 0",
                          },

                          max: {
                            value: 100,
                            message: "Percentage cannot be greater than 100",
                          },

                          validate: (value) =>
                            Number(value) >= 0 || "Invalid percentage amount",
                        })}
                        onKeyDown={(e) => {
                          // Allow backspace, left arrow, right arrow, and digits
                          if (
                            !(
                              e.key === "Backspace" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight" ||
                              (e.key >= "0" && e.key <= "9")
                            )
                          ) {
                            e.preventDefault(); // Prevent default action for non-allowed keys
                          }
                        }}
                      />
                      {errors.cap_percent && (
                        <span className="text-danger">
                          {errors.cap_percent.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col> */}

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Withdrawal TDS Charges Percentage</Form.Label>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name={`tds_percentage`}
                        placeholder="Withdrawal TDS Charges Percentage"
                        className={classNames("", {
                          "is-invalid": errors?.tds_percentage, // Adjusted error checking
                        })}
                        {...register(`tds_percentage`, {
                          required:
                            "Withdrawal TDS Charges Percentage is required",

                          min: {
                            value: 0,
                            message:
                              "Percentage must be greater than or equal to 0",
                          },

                          max: {
                            value: 100,
                            message: "Percentage cannot be greater than 100",
                          },

                          validate: (value) =>
                            Number(value) >= 0 || "Invalid percentage amount",
                        })}
                        onKeyDown={(e) => {
                          // Allow backspace, left arrow, right arrow, and digits
                          if (
                            !(
                              e.key === "Backspace" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight" ||
                              (e.key >= "0" && e.key <= "9")
                            )
                          ) {
                            e.preventDefault(); // Prevent default action for non-allowed keys
                          }
                        }}
                      />
                      {errors.tds_percentage && (
                        <span className="text-danger">
                          {errors.tds_percentage.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col> */}
              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Withdrawal Admin Percentage</Form.Label>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name={`admin_percentage`}
                        placeholder="Withdrawal Admin Percentage"
                        className={classNames("", {
                          "is-invalid": errors?.admin_percentage, // Adjusted error checking
                        })}
                        {...register(`admin_percentage`, {
                          required: "Withdrawal Admin Percentage is required",

                          min: {
                            value: 0,
                            message:
                              "Percentage must be greater than or equal to 0",
                          },

                          max: {
                            value: 100,
                            message: "Percentage cannot be greater than 100",
                          },

                          validate: (value) =>
                            Number(value) >= 0 || "Invalid percentage amount",
                        })}
                        onKeyDown={(e) => {
                          // Allow backspace, left arrow, right arrow, and digits
                          if (
                            !(
                              e.key === "Backspace" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight" ||
                              (e.key >= "0" && e.key <= "9")
                            )
                          ) {
                            e.preventDefault(); // Prevent default action for non-allowed keys
                          }
                        }}
                      />
                      {errors.admin_percentage && (
                        <span className="text-danger">
                          {errors.admin_percentage.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col> */}

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Website URL</Form.Label>
                    <Form.Group>
                      <Form.Control
                        type="url"
                        name="website_url"
                        placeholder="https://example.com"
                        className={classNames("", {
                          "is-invalid": errors?.website_url,
                        })}
                        {...register("website_url", {
                          required: "Website URL is required",
                          pattern: {
                            value:
                              /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/i,
                            message: "Please enter a valid website URL",
                          },
                        })}
                      />

                      {errors.website_url && (
                        <span className="text-danger">
                          {errors.website_url.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              {/* <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Refer By Percentage</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`refer_percentage`}
                      placeholder="refer percentage"
                      className={classNames("", {
                        "is-invalid": errors?.refer_percentage, // Adjusted error checking
                      })}
                      {...register(`refer_percentage`, {
                        required: {
                          message: "refer percentage required ", // Custom required message
                        },
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.refer_percentage && (
                      <span className="text-danger">
                        {errors.refer_percentage.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>
             <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Refer To Percentage</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`refer_to_percentage`}
                      placeholder="Refer To percentage"
                      className={classNames("", {
                        "is-invalid": errors?.refer_to_percentage, // Adjusted error checking
                      })}
                      {...register(`refer_to_percentage`, {
                        required: {
                          message: "refer percentage required ", // Custom required message
                        },
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.refer_to_percentage && (
                      <span className="text-danger">
                        {errors.refer_to_percentage.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Refer By Order</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`refer_by_order`}
                      placeholder="refer percentage"
                      className={classNames("", {
                        "is-invalid": errors?.refer_by_order, // Adjusted error checking
                      })}
                      {...register(`refer_by_order`, {
                        required: {
                          message: "refer By Order required ", // Custom required message
                        },
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.refer_by_order && (
                      <span className="text-danger">
                        {errors.refer_by_order.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Refer To Order</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`refer_to_order`}
                      placeholder="refer percentage"
                      className={classNames("", {
                        "is-invalid": errors?.refer_to_order, // Adjusted error checking
                      })}
                      {...register(`refer_to_order`, {
                        required: {
                          message: "refer To Order required ", // Custom required message
                        },
                      })}
                      onKeyDown={(e) => {
                        // Allow backspace, left arrow, right arrow, and digits
                        if (
                          !(
                            e.key === "Backspace" ||
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowRight" ||
                            (e.key >= "0" && e.key <= "9")
                          )
                        ) {
                          e.preventDefault(); // Prevent default action for non-allowed keys
                        }
                      }}
                    />
                    {errors.refer_to_order && (
                      <span className="text-danger">
                        {errors.refer_to_order.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col> */}

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Address</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        as="textarea"
                        name="address"
                        placeholder="Address"
                        className={classNames("", {
                          "is-invalid": errors?.address,
                        })}
                        {...register("address", {
                          required: "Address Is Required",
                          // validate: (value) =>
                          //   value.length <= 200 ||
                          //   "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.address && (
                      <span className="text-danger">
                        {errors.address.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Billing Address</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        as="textarea"
                        name="address"
                        placeholder="Address"
                        className={classNames("", {
                          "is-invalid": errors?.second_address,
                        })}
                        {...register("second_address", {
                          // required: "Address Is Required",
                          // validate: (value) =>
                          //   value.length <= 200 ||
                          //   "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.second_address && (
                      <span className="text-danger">
                        {errors.second_address.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Contact Person</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        as="textarea"
                        name="contact_person"
                        placeholder="Contact Person"
                        className={classNames("", {
                          "is-invalid": errors?.contact_person,
                        })}
                        {...register("contact_person", {
                          required: "Contact Person Is Required",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.contact_person && (
                      <span className="text-danger">
                        {errors.contact_person.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    <Form.Label className="text-left">Logo</Form.Label>

                    <Form.Group>
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.logo,
                        })}
                        type="file"
                        {...register("logo", {
                          // validate: async (value) => {
                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg", "webp"];
                          //     const fileType = value[0].name?.split(".")[1];
                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (
                          //       sizes.width !== 420 &&
                          //       sizes.height !== 520
                          //     ) {
                          //       return "Image width and height must be 420 px and 520 px";
                          //     }
                          //     const fileSize = Math.round(
                          //       value[0].size / 1024
                          //     );
                          //     if (fileSize > 500) {
                          //       return "file size must be lower than 500kb";
                          //     }
                          //   }
                          // },
                        })}
                        accept="image/png,image/jpeg,image/webp"
                      />
                    </Form.Group>
                    {errors.logo && (
                      <span className="text-danger">{errors.logo.message}</span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Image Preview</Form.Label>

                  {typeof getValues("logo") == "string" ? (
                    <div className="image-preview-container">
                      <img
                        src={IMG_URL + getValues("logo")}
                        alt="Preview"
                        className="image-preview"
                      />
                    </div>
                  ) : (
                    imageFile &&
                    imageFile?.length > 0 && (
                      <div className="image-preview-container">
                        <img
                          // src={URL.createObjectURL(getValues("image")[0])}
                          src={URL?.createObjectURL(imageFile[0])}
                          alt="Preview"
                          className="image-preview"
                        />
                      </div>
                    )
                  )}
                </div>
              </Col>

              <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-start">
                  <Form.Label className="text-left">
                    QR Image <span className="text-danger">*</span>
                  </Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.qr_image,
                      })}
                      type="file"
                      {...register("qr_image", {
                        validate: (value) => {
                          if (typeof value === "string" && value) return true;
                          const file = value?.[0];
                          if (!file) return "QR Image is required";
                          if (
                            !["image/jpeg", "image/png", "image/webp"].includes(
                              file.type,
                            )
                          ) {
                            return "Please upload a valid image (jpg, jpeg, png, webp)";
                          }
                          if (file.size > 2 * 1024 * 1024) {
                            return "File size must be lower than 2MB";
                          }
                          return true;
                        },
                      })}
                      accept=".png"
                    />
                  </Form.Group>
                  {errors.qr_image && (
                    <span className="text-danger">
                      {errors.qr_image.message}
                    </span>
                  )}
                </Row>
              </div>
            </Col>

            <Col lg={6}>
              <div className="main-form-section mt-3">
                <Form.Label>Image Preview</Form.Label>

                {typeof getValues("qr_image") == "string" ? (
                  <div className="image-preview-container">
                    <img
                      src={IMG_URL + getValues("qr_image")}
                      alt="Preview"
                      className="image-preview"
                    />
                  </div>
                ) : (
                  imageFileQR &&
                  imageFileQR?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(imageFileQR[0])}
                        alt="Preview"
                        className="image-preview"
                      />
                    </div>
                  )
                )}
              </div>
            </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link to={"/settings/app-setup"}>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    loading={submitLoading}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        )}
      </section>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
